import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import styles from './../styles-jss'
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import Loader from '../../../../components/Loader/Loader';
import { withUIContext } from '../../../../context';

//Table
import AddCatalogue from '../../../../components/Catalogue/AddCatalogue';
import Header from '../../../../components/Catalogue/Header';
import TableCatalogue from '../../../../components/Catalogue/TableCatalogue';

//Form
import { InputLabel } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import Sort from '@material-ui/icons/Sort';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
//import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import { TextValidator, SelectValidator } from 'react-material-ui-form-validator';

//Services
import { apiPOST } from '../../../../services/service_base';
import { getObjectById, getFilteredData } from '../../../../helpers/general';

//Notifications
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../../../components/Notification/CustomNotification';

class Catalogo extends React.Component {
    state = {
        //Open form
        openForm: false,
        //Table
        headers: ["ID", "Empresa/Proveedor", "Tipo de persona", "País origen", "Dirección", "Teléfono",
            "Estatus", "Opciones"],
        rawData: [],
        data: [],
        //Selected catalogue item
        selected: null,
        proTipoPersona: "fisica",
        proPaisOrigin: "",

        proNombre: "",
        proNombreRepresentante: "",
        proCorreoDelRepresentante: "",
        proNombreContactoVenta: "",
        proCorreoContactoVenta: "",
        proNombreContactoLegal: "",
        proCorreoContactoLegal: "",
        proNombreContactoAdministrativo: "",
        proCorreoContactoAdministrativo: "",
        proDireccion: "",
        proTelefono: "",
        proPaginaWeb: "",
        proRfc: "",
        proNumeroPasaporte: "",
        proPrimerNombre: "",
        proSegundoNombre: "",
        proApellidoPaterno: "",
        proApellidoMaterno: "",
        //Error 
        openError: false,
        isLoading: false,
        //Catalogues
        countries: [],
        chkDeleteCatalog: false,
        chkEditCatalog: false,
        chkNewCatalog: false
    };

    //Open and close form
    handledOpenForm = (item) => {
        //Clear Form 
        this.handleClear();

        if (item !== undefined) {
            let auxItem = this.state.rawData.find(it => it.id === item.id);
            this.setState({
                openForm: true,
                proPaisOrigin: auxItem.id_pais_origen.toString(),
                proTipoPersona: auxItem.tipo_persona,
                proNombre: auxItem.nombre_proveedor || "",
                proNombreRepresentante: auxItem.nombre_representante || "",
                proCorreoDelRepresentante: auxItem.correo_del_representante || "",
                proNombreContactoVenta: auxItem.nombre_contacto_de_venta || "",
                proCorreoContactoVenta: auxItem.correo_contacto_venta || "",
                proNombreContactoLegal: auxItem.nombre_contacto_legal || "",
                proCorreoContactoLegal: auxItem.coreo_contacto_legal || "",
                proNombreContactoAdministrativo: auxItem.nombre_contacto_administrativo || "",
                proCorreoContactoAdministrativo: auxItem.correo_contacto_administrativo || "",
                proDireccion: auxItem.direccion || "",
                proTelefono: auxItem.telefono || "",
                proPaginaWeb: auxItem.pagina_web || "",
                proRfc: auxItem.rfc || "",
                proNumeroPasaporte: auxItem.numero_pasaporte || "",
                proPrimerNombre: auxItem.primerNombre || "",
                proSegundoNombre: auxItem.segundoNombre || "",
                proApellidoPaterno: auxItem.apellidoPaterno || "",
                proApellidoMaterno: auxItem.apellidoMaterno || "",
                selected: item
            });
        }
        else {
            this.setState({
                openForm: true,
            });
        }
    }

    handledCloseForm = () => {
        this.setState({ openForm: false });
    }

    //Handle Form
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleClear = () => {
        this.setState({
            proPaisOrigin: "",
            selected: null,
            proNombre: "",
            proNombreRepresentante: "",
            proCorreoDelRepresentante: "",
            proNombreContactoVenta: "",
            proCorreoContactoVenta: "",
            proNombreContactoLegal: "",
            proCorreoContactoLegal: "",
            proNombreContactoAdministrativo: "",
            proCorreoContactoAdministrativo: "",
            proDireccion: "",
            proTelefono: "",
            proPaginaWeb: "",
            proRfc: "",
            proNumeroPasaporte: "",
            proPrimerNombre: "",
            proSegundoNombre: "",
            proApellidoPaterno: "",
            proApellidoMaterno: ""
        });
    }

    //Notifications
    handleClose = () => {
        this.setState({ openError: false });
    }

    //Catalogue CRUD

    //Catalogue CRUD
    handleBodyRequest = (item, status) => {
        let auxItem = getObjectById(this.state.rawData, item);
        if (auxItem) {
            return {
                idCatalog: 18,
                id_record: auxItem.id,
                "new_provider_name": auxItem.tipo_persona === "fisica" ? `${auxItem.primerNombre} ${auxItem.segundoNombre} ${auxItem.apellidoPaterno} ${auxItem.apellidoMaterno}` : auxItem.nombre_proveedor,
                "new_physical_moral": auxItem.tipo_persona,
                "new_representative_name": auxItem.nombre_representante,
                "new_representantive_mail": auxItem.correo_del_representante,
                "new_sales_contact_name": auxItem.nombre_contacto_de_venta,
                "new_sales_contact_mail": auxItem.correo_contacto_venta,
                "new_legal_contact_name": auxItem.nombre_contacto_legal,
                "new_legal_contact_mail": auxItem.correo_contacto_legal,
                "new_administrative_contact_name": auxItem.nombre_contacto_administrativo,
                "new_administrative_contact_mail": auxItem.correo_contacto_administrativo,
                "new_country": auxItem.id_pais_origen,
                "new_provider_address": auxItem.direccion,
                "new_telephone": auxItem.telefono,
                "new_web_page": auxItem.pagina_web,
                "new_rfc": auxItem.rfc,
                "new_passport_number": auxItem.numero_pasaporte,
                "new_first_name": auxItem.primerNombre,
                "new_second_name": auxItem.segundoNombre,
                "new_last_name": auxItem.apellidoPaterno,
                "new_mothers_last_name": auxItem.apellidoMaterno,
                "new_status": status
            }
        } else {
            return {
                idCatalog: 18,
                id_record: item.id,
                "new_provider_name": "",
                "new_physical_moral": "",
                "new_representative_name": "",
                "new_representantive_mail": "",
                "new_sales_contact_name": "",
                "new_sales_contact_mail": "",
                "new_legal_contact_name": "",
                "new_legal_contact_mail": "",
                "new_administrative_contact_name": "",
                "new_administrative_contact_mail": "",
                "new_country": "",
                "new_provider_address": "",
                "new_telephone": "",
                "new_web_page": "",
                "new_rfc": "",
                "new_passport_number": "",
                "new_first_name": "",
                "new_second_name": "",
                "new_last_name": "",
                "new_mothers_last_name": "",
                "new_status": status
            }
        }
    }

    handleDeleteItem = (item) => {
        const body = this.handleBodyRequest(item, 2);

        apiPOST('/catalogue/update', body).then(
            response => {
                if (response.status === 200) {
                    let auxIndex = this.state.data.findIndex(itm => itm.id === item.id),
                        auxRawIndex = this.state.data.findIndex(itm => itm.id === item.id);

                    let auxData = [...this.state.data], auxRawData = [...this.state.rawData];

                    auxData.splice(auxIndex, 1);
                    auxRawData.splice(auxRawIndex, 1);

                    this.setState({ data: auxData, rawData: auxRawData, selected: undefined, openForm: false, isLoading: false });
                }
                else {
                    this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                }
            }
        ).catch(
            err => {
                this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
            }
        )
    }

    handleUpdateStatus = (data, item) => {

        const body = this.handleBodyRequest(item, item.estatus === 1 ? 0 : 1);

        apiPOST('/catalogue/update', body).then(
            response => {
                if (response.status === 200) {
                    let auxData = [...this.state.data], auxRawData = [...this.state.rawData];
                    let auxIndex = this.state.data.findIndex(itm => itm.id === item.id), auxRawIndex = this.state.rawData.findIndex(itm => itm.id === item.id);

                    auxData[auxIndex].estatus = response.data[0].estatus;
                    auxRawData[auxRawIndex].estatus = response.data[0].estatus;

                    this.setState({ data: auxData, rawData: auxRawData, selected: undefined, openForm: false, isLoading: false });
                }
                else {
                    this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                }
            }
        ).catch(
            err => {
                this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
            }
        )
    }

    handleSubmit = (event) => {
        event.preventDefault();

        let body = {
            "idCatalog": 18,
            "id_record": this.state.selected ? this.state.selected.id : 0,
            "new_provider_name": this.state.proTipoPersona === "fisica" ? `${this.state.proPrimerNombre} ${this.state.proSegundoNombre} ${this.state.proApellidoPaterno} ${this.state.proApellidoMaterno}` : this.state.proNombre,
            "new_physical_moral": this.state.proTipoPersona,
            "new_representative_name": this.state.proNombreRepresentante,
            "new_representantive_mail": this.state.proCorreoDelRepresentante,
            "new_sales_contact_name": this.state.proNombreContactoVenta,
            "new_sales_contact_mail": this.state.proCorreoContactoVenta,
            "new_legal_contact_name": this.state.proNombreContactoLegal,
            "new_legal_contact_mail": this.state.proCorreoContactoLegal,
            "new_administrative_contact_name": this.state.proNombreContactoAdministrativo,
            "new_administrative_contact_mail": this.state.proCorreoContactoAdministrativo,
            "new_country": this.state.proPaisOrigin,
            "new_provider_address": this.state.proDireccion,
            "new_telephone": this.state.proTelefono ? this.state.proTelefono : " ",
            "new_web_page": this.state.proPaginaWeb,
            "new_rfc": this.state.proRfc,
            "new_passport_number": this.state.proNumeroPasaporte,
            "new_first_name": this.state.proPrimerNombre,
            "new_second_name": this.state.proSegundoNombre,
            "new_last_name": this.state.proApellidoPaterno,
            "new_mothers_last_name": this.state.proApellidoMaterno,
            "new_status": this.state.selected ? this.state.selected.estatus : true
        }

        //Call to lambda -- when success it should do this 
        let auxData = [...this.state.data];
        let auxRawData = [...this.state.rawData];
        this.setState({ isLoading: true });

        if (this.state.selected) {
            apiPOST('/catalogue/update', body).then(
                response => {
                    if (response.status === 200) {
                        //console.log(response); 
                        let auxItem = response.data[0];
                        let auxIndex = this.state.data.findIndex(itm => itm.id === this.state.selected.id);

                        auxRawData[auxIndex] = auxItem;
                        auxItem = {
                            "id": auxItem.id,
                            "nombre_proveedor": auxItem.nombre_proveedor,
                            "tipo_persona": auxItem.tipo_persona,
                            "pais_origen": auxItem.pais_origen,
                            "direccion": auxItem.direccion,
                            "telefono": auxItem.telefono,
                            "estatus": auxItem.estatus
                        }
                        auxData[auxIndex] = auxItem;

                        this.setState({ data: auxData, rawData: auxRawData, selected: undefined, openForm: false, isLoading: false });
                    }
                    else {
                        //console.log(response)
                        this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                    }
                }
            ).catch(
                err => {
                    //.log(err); 
                    this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                }
            )
        } else {
            //for dummy only, service returns inserted item with id 
            apiPOST('/catalogue/add', body).then(
                response => {
                    if (response.status === 200) {
                        let auxItem = response.data[0];
                        auxRawData.push(auxItem);

                        auxItem = {
                            "id": auxItem.id,
                            "nombre_proveedor": auxItem.nombre_proveedor,
                            "tipo_persona": auxItem.tipo_persona,
                            "pais_origen": auxItem.pais_origen,
                            "direccion": auxItem.direccion,
                            "telefono": auxItem.telefono,
                            "estatus": auxItem.estatus
                        }
                        auxData.push(auxItem);
                        auxData.sort((a, b) => (a.nombre_proveedor || "").localeCompare(b.nombre_proveedor || "", 'es'));
                        auxRawData.sort((a, b) => (a.nombre_proveedor || "").localeCompare(b.nombre_proveedor || "", 'es'));

                        this.setState({ data: auxData, rawData: auxRawData, selected: undefined, openForm: false, isLoading: false });
                    } else {
                        this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                    }
                }
            ).catch(
                err => {
                    this.setState({ openError: true, selected: undefined, openForm: false, isLoading: false });
                }
            )
        }
    }

    //Reduce a raw provider record to the fields rendered by the table (must match state.headers)
    reduceProvider = (auxCompany) => ({
        "id": auxCompany.id,
        "nombre_proveedor": auxCompany.nombre_proveedor ? auxCompany.nombre_proveedor : '',
        "tipo_persona": auxCompany.tipo_persona,
        "pais_origen": auxCompany.pais_origen ? auxCompany.pais_origen : '',
        "direccion": auxCompany.direccion ? auxCompany.direccion : '',
        "telefono": auxCompany.telefono ? auxCompany.telefono : '',
        "estatus": auxCompany.estatus
    })

    handleSearch = (search) => {
        let key = search.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
        let auxRawData = key === "" ? [...this.state.rawData] : getFilteredData([...this.state.rawData], "nombre_proveedor", key);

        this.setState({ data: auxRawData.map(this.reduceProvider) });
    }

    componentDidMount() {
        let config = JSON.parse(localStorage.getItem("user_permissions")).filter(x => x.menu_id === 6)[0];
        let configPermission = JSON.parse(config.grant_configuration);

        this.setState({
            chkDeleteCatalog: configPermission.chkDeleteCatalog,
            chkEditCatalog: configPermission.chkEditCatalog,
            chkNewCatalog: configPermission.chkNewCatalog
        });
        //Get countries catalogue
        apiPOST('/catalogue/get', { idCatalogo: 3 }, true).then(
            response => {
                if (response.status === 200) {
                    this.setState({ countries: response.data })
                }
            }
        ).catch(err => console.log("Error loading countries: ", err))

        //Get Data
        apiPOST('/catalogue/getComplete', { idCatalog: 18 }).then(
            response => {
                if (response.status === 200) {
                    const sortedRaw = response.data.sort((a, b) => (a.nombre_proveedor || "").localeCompare(b.nombre_proveedor || "", 'es'));
                    let auxData = sortedRaw.map(this.reduceProvider);

                    this.setState({ isLoading: false, rawData: sortedRaw, data: auxData });
                } else {
                    this.setState({ isLoading: false, openError: true });
                }
            }
        ).catch(
            err => {
                this.setState({ isLoading: false, openError: true });
            }
        )
    }

    render() {
        const { classes, uicontext } = this.props;

        return (
            <div className="marginTopLogo">

                <Paper className={classes.root}>
                    <Header
                        title="Empresas/Proveedores"
                        tooltip="Nuevo Empresa/Proveedor"
                        textBtn="Nuevo"
                        openForm={() => this.handledOpenForm(undefined)}
                        canAdd={this.state.chkNewCatalog}
                        catalogue={18}
                        search={this.handleSearch}
                    />
                    {
                        this.state.isLoading ?
                            <Loader text={"Cargando"} /> :
                            <TableCatalogue
                                headers={this.state.headers}
                                data={this.state.data}
                                openForm={this.handledOpenForm}
                                deleteItem={this.handleDeleteItem}
                                updateStatus={this.handleUpdateStatus}
                                canEdit={this.state.chkEditCatalog}
                                canDelete={this.state.chkDeleteCatalog}
                            />
                    }
                </Paper>
                {
                    uicontext.state.isCatalogEdit ? null :


                        <AddCatalogue
                            openForm={this.state.openForm}
                            closeForm={this.handledCloseForm}
                            classes={classes}
                            submit={this.handleSubmit}
                            clearForm={this.handleClear}
                            title="Empresa/Proveedor"
                            catalogue={18}
                        >
                            <div>
                                <Grid container spacing={24}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl className={classNames(classes.formControl, classes.w100)}>
                                            <InputLabel htmlFor="">Tipo de persona*</InputLabel>
                                            <Select
                                                label="Tipo de persona"
                                                placeholder="Elige una opción"
                                                value={this.state.proTipoPersona}
                                                onChange={this.handleChange}
                                                name="proTipoPersona"
                                                displayEmpty
                                                className={classes.field}
                                                inputProps={{ name: 'proTipoPersona' }}
                                                InputLabelProps={{ shrink: true }}
                                            >
                                                <MenuItem value={'fisica'}>Física</MenuItem>
                                                <MenuItem value={'moral'}>Moral</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>
                            {
                                this.state.proTipoPersona === 'fisica' ?
                                    <div>
                                        {/*Persona Fisica*/}
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Primer Nombre*"
                                                        placeholder="Ej. María"
                                                        id="proPrimerNombre"
                                                        name="proPrimerNombre"
                                                        value={this.state.proPrimerNombre}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['required', 'maxStringLength:50']}
                                                        errorMessages={['(Campo requerido)', '(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Segundo Nombre"
                                                        placeholder="Ej. Concepción"
                                                        id="proSegundoNombre"
                                                        name="proSegundoNombre"
                                                        value={this.state.proSegundoNombre}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Apellido Paterno*"
                                                        placeholder="Ej. Gutiérrez"
                                                        id="proApellidoPaterno"
                                                        name="proApellidoPaterno"
                                                        value={this.state.proApellidoPaterno}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['required', 'maxStringLength:50']}
                                                        errorMessages={['(Campo requerido)', '(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Apellido Materno"
                                                        placeholder="Ej. Morales"
                                                        id="proApellidoMaterno"
                                                        name="proApellidoMaterno"
                                                        value={this.state.proApellidoMaterno}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        {/*Pais*/}
                                        <Grid container spacing={24}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <FormControl className={classNames(classes.formControl, classes.w100)}>
                                                    <SelectValidator
                                                        label="Pais origen*"
                                                        value={this.state.proPaisOrigin}
                                                        onChange={this.handleChange}
                                                        name="proPaisOrigin"
                                                        className={classes.selectEmpty}
                                                        inputProps={{ name: 'proPaisOrigin', id: 'filter-pais' }}
                                                        InputLabelProps={{ shrink: true }}
                                                        validators={['required']}
                                                        errorMessages={['(Campo requerido)']}
                                                    >
                                                        <MenuItem value="">Selecciona...</MenuItem>
                                                        {
                                                            this.state.countries.map((country, idx) => (
                                                                <MenuItem value={country.value} key={`countryF${idx}`}>
                                                                    {country.data}
                                                                </MenuItem>))
                                                        }
                                                    </SelectValidator>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={4}>
                                                    <TextValidator
                                                        label="Télefono"
                                                        placeholder="Ej. 4771253635"
                                                        id="proTelefono"
                                                        name="proTelefono"
                                                        value={this.state.proTelefono}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:13']}
                                                        errorMessages={['(Número de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={8}>
                                                    <TextValidator
                                                        label="RFC"
                                                        placeholder="Ej. UYYR880416"
                                                        id="proRfc"
                                                        name="proRfc"
                                                        value={this.state.proRfc}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:13']}
                                                        errorMessages={['(Número de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Número de pasaporte"
                                                        placeholder="Ej. 145632897"
                                                        id="proNumeroPasaporte"
                                                        name="proNumeroPasaporte"
                                                        value={this.state.proNumeroPasaporte}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:13']}
                                                        errorMessages={['(Número de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Dirección"
                                                        placeholder="Ej. Valle de Bravo 345"
                                                        id="proDireccion"
                                                        name="proDireccion"
                                                        value={this.state.proDireccion}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:200']}
                                                        errorMessages={['(Número de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <TextValidator
                                                        label="Página web"
                                                        placeholder="Ej. www.sitioweb.com"
                                                        id="proPaginaWeb"
                                                        name="proPaginaWeb"
                                                        value={this.state.proPaginaWeb}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div> :
                                    <div>
                                        {/*Persona Moral*/}
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Nombre de la empresa*"
                                                        placeholder="Ej. Televisa"
                                                        id="proNombre"
                                                        name="proNombre"
                                                        value={this.state.proNombre}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['required', 'maxStringLength:150']}
                                                        errorMessages={['(Campo requerido)', '(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={6}>
                                                    <FormControl className={classNames(classes.formControl, classes.w100)}>
                                                        <SelectValidator
                                                            label="Pais origen*"
                                                            value={this.state.proPaisOrigin}
                                                            onChange={this.handleChange}
                                                            name="proPaisOrigin"
                                                            className={classes.selectEmpty}
                                                            inputProps={{ name: 'proPaisOrigin', id: 'filter-pais' }}
                                                            InputLabelProps={{ shrink: true }}
                                                            validators={['required']}
                                                            errorMessages={['(Campo requerido)']}
                                                        >
                                                            <MenuItem value="">Selecciona...</MenuItem>
                                                            {
                                                                this.state.countries.map((country, idx) => (
                                                                    <MenuItem value={country.value} key={`countryF${idx}`}>
                                                                        {country.data}
                                                                    </MenuItem>))
                                                            }
                                                        </SelectValidator>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={4}>
                                                    <TextValidator
                                                        label="Télefono"
                                                        placeholder="Ej. 4778965412"
                                                        id="proTelefono"
                                                        name="proTelefono"
                                                        value={this.state.proTelefono}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:13']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={8}>
                                                    <TextValidator
                                                        label="RFC"
                                                        placeholder="Ej. OOFJ880625"
                                                        id="proRfc"
                                                        name="proRfc"
                                                        value={this.state.proRfc}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:12']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={7}>
                                                    <TextValidator
                                                        label="Dirección"
                                                        placeholder="Ej. Villa Magna 378"
                                                        id="proDireccion"
                                                        name="proDireccion"
                                                        value={this.state.proDireccion}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:200']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={5}>
                                                    <TextValidator
                                                        label="Página web"
                                                        placeholder="Ej. www.sitioweb.com"
                                                        id="proPaginaWeb"
                                                        name="proPaginaWeb"
                                                        value={this.state.proPaginaWeb}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Nombre del representante"
                                                        placeholder="Ej. Francisco Hernández"
                                                        id="proNombreRepresentante"
                                                        name="proNombreRepresentante"
                                                        value={this.state.proNombreRepresentante}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:100']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Correo del representante"
                                                        placeholder="Ej. ejemplo@ejemplo.com"
                                                        id="proCorreoDelRepresentante"
                                                        name="proCorreoDelRepresentante"
                                                        value={this.state.proCorreoDelRepresentante}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50', 'isEmail']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)', 'Correo electronico invalido']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Contacto de ventas"
                                                        placeholder="Ej. Sandra Contreras"
                                                        id="proNombreContactoVenta"
                                                        name="proNombreContactoVenta"
                                                        value={this.state.proNombreContactoVenta}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:100']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Correo contacto de ventas"
                                                        placeholder="Ej. ejemplo@ejemplo.com"
                                                        id="proCorreoContactoVenta"
                                                        name="proCorreoContactoVenta"
                                                        value={this.state.proCorreoContactoVenta}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50', 'isEmail']}
                                                        errorMessages={['(Número de caracteres sobrepasados)', 'Correo electrónico inválido']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Nombre contacto legal"
                                                        placeholder="Ej. Josue Valdez"
                                                        id="proNombreContactoLegal"
                                                        name="proNombreContactoLegal"
                                                        value={this.state.proNombreContactoLegal}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:100']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Correo contacto legal"
                                                        placeholder="Ej. ejemplo@ejemplo.com"
                                                        id="proCorreoContactoLegal"
                                                        name="proCorreoContactoLegal"
                                                        value={this.state.proCorreoContactoLegal}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50', 'isEmail']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)', 'Correo electronico invalido']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Contacto administrativo"
                                                        placeholder="Ej. Hugo Castro"
                                                        id="proNombreContactoAdministrativo"
                                                        name="proNombreContactoAdministrativo"
                                                        value={this.state.proNombreContactoAdministrativo}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:100']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <TextValidator
                                                        label="Correo contacto adtvo."
                                                        placeholder="Ej. ejemplo@ejemplo.com"
                                                        id="proCorreoContactoAdministrativo"
                                                        name="proCorreoContactoAdministrativo"
                                                        value={this.state.proCorreoContactoAdministrativo}
                                                        className={classNames(classes.field, classes.w100)}
                                                        onChange={this.handleChange}
                                                        validators={['maxStringLength:50', 'isEmail']}
                                                        errorMessages={['(Numero de caracteres sobrepasados)', 'Correo electronico invalido']}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                            }

                        </AddCatalogue>
                }
                {/*For notifications*/}
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={this.state.openError}
                    autoHideDuration={6000}
                    onClose={this.handleClose}>
                    <CustomNotification
                        onClose={this.handleClose}
                        variant="error"
                        message={"Ocurrio un error inesperado"} />
                </Snackbar>
            </div>
        )
    }
}

export default withUIContext(withStyles(styles)(Catalogo));